import React from 'react';
import { connect } from 'react-redux';
import { createManagedProduct } from 'js/actions/managed-product-actions';
import { useNotify } from 'js/hooks/useNotify';
import { useHistory, useParams } from 'react-router-dom';
import CreateManagedProductComponent from '../components/CreateManagedProduct';

function CreateManagedProduct({ createManagedProduct }) {
  const notify = useNotify();
  const history = useHistory();
  const { workspaceId } = useParams();

  const handleSubmit = async (values) => {
    // e.preventDefault();
    try {
      const result = await createManagedProduct(values);
      notify({
        type: 'success',
        message: 'Product created successfully',
      });
      history.push(`/w/${workspaceId}/pm/products`);
      return result;
    } catch (error) {
      notify({
        type: 'danger',
        message: 'Failed to create product',
      });
    }
  };

  return <CreateManagedProductComponent onSubmit={handleSubmit} />;
}

export default connect(null, { createManagedProduct })(CreateManagedProduct);
